import React, { FC, useEffect, useState } from 'react';

import { v4 as uuid } from 'uuid';

import { Box } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import { formatDateOrdinalWithClock } from '~/services/TimeService';
import UsersService from '~/services/UsersService';

import { reportError } from '~/utils/reportError';

import GridPagination from '../Common/Elements/GridPagination';

type Props = {
  userId: string;
};

const columns: Array<GridColDef> = [
  {
    field: 'old_email',
    headerName: 'Old Email',
    flex: 2,
    display: 'flex',
  },
  {
    field: 'new_email',
    headerName: 'New Email',
    flex: 2,
    display: 'flex',
  },
  {
    field: 'completed_at',
    headerName: 'Completed At',
    flex: 2,
    valueGetter: (_value, row) => formatDateOrdinalWithClock(row.completed_at),
    display: 'flex',
  },
  {
    field: 'requested_at',
    headerName: 'Requested At',
    flex: 2,
    valueGetter: (_value, row) => formatDateOrdinalWithClock(row.requested_at),
    display: 'flex',
  },
];

const UserEmailChangeTable: FC<Props> = ({ userId }: Props) => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);

  useEffect(() => {
    UsersService.getEmailChangeHistory(userId)
      .then((response) => setResult(response.result))
      .catch((error) => reportError(error))
      .finally(() => setLoading(false));
  }, [userId]);

  return (
    <Box>
      <DataGrid
        rows={result || []}
        columns={columns}
        getRowId={() => uuid()}
        autoHeight
        loading={loading}
        initialState={{
          pagination: { paginationModel: { pageSize: 5 } },
        }}
        pageSizeOptions={[5]}
        paginationModel={{ pageSize: 5, page }}
        onPaginationModelChange={({ page }) => setPage(page)}
        disableColumnMenu
        disableRowSelectionOnClick
        density="compact"
        slots={{ pagination: GridPagination }}
      />
    </Box>
  );
};

export default UserEmailChangeTable;
